import { Route } from "vue-router";
import { OAuthMiddleware, LoggerService as lgg } from "vue-components-library";

import Store from "@/App/store";
import AuthorizationService from "@/Login/services/Authorization.Service";

const WHITELIST = ["/login"];
const LOG_TAG = "[LOGGED IN MIDDLEWARE]";

export async function isLoggedIn(to: Route, from: Route, next: Function) {
  const isAuthenticated = Store.getters["Login/authToken"];

  try {
    await Store.dispatch("Login/setupWorkspaceApp");
  } catch (error) {
    lgg.error(`${LOG_TAG} Failed to setup Workspace App`, { error });
  }

  if (!isAuthenticated && !WHITELIST.includes(to.path)) {
    next("/login");
    return;
  } else if (!isAuthenticated) {
    OAuthMiddleware.setTokenHandlers({
      verify(idToken: string) {
        return AuthorizationService.loginByToken(idToken);
      },
      success(loginResponse) {
        Store.dispatch("Login/setupUser", loginResponse).then(() => next("/"));
      },
      error(error: Error) {
        Store.dispatch("Login/setGeneralError", error);
      }
    });

    const workspaceApp = Store.getters["Login/workspaceApp"];

    return OAuthMiddleware.handle(next, workspaceApp);
  } else {
    /**
     * Should continue to regular next step (expected route).
     */
    next();
  }
}
